import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { ProductViewLayoutComponent } from '../view-layout/product-view-layout.component';
@Directive()
export abstract class AbstractProductCmsComponent<T extends NICmsContentComponent.IData = NICmsContentComponent.IData>
    extends UiComponent
    implements NICmsContentComponent.IComponent, OnInit
{
    @ICmsContent({
        type: 'component'
    })
    component!: T;
    constructor(
        protected elementRef: ElementRef,
        protected renderer2: Renderer2,
        public productViewLayoutComponent: ProductViewLayoutComponent
    ) {
        super();
    }
    override ngOnInit(): void {
        super.ngOnInit();
        this.subscriptions.add(this.productViewLayoutComponent.productChange.subscribe(() => this.detectChanges()));
    }
    get product() {
        return this.productViewLayoutComponent.product;
    }
    get parent() {
        return this.productViewLayoutComponent.parent;
    }
}
